jQuery(document).ready(function ($) {
  /* CF7: Add Checkmarks to Checkbox for Custom Style */
  if ($('.wpcf7-form input[type="checkbox"]')) {
    $('<span class="checkmark"></span>').insertAfter($('.wpcf7-form input[type="checkbox"]'));
  }
});
